// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Loading__container-d81841 {
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/main/Calendar/Loading/Landing.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;AACF","sourcesContent":[".container {\n  display: flex;\n  height: 100%;\n  align-items: center;\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Loading__container-d81841`
};
module.exports = ___CSS_LOADER_EXPORT___;
